var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.551177 5.60209C3.73892 8.15303 6.92667 10.704 10.1144 13.2549C10.5718 13.6209 11.2173 13.6916 11.6649 13.2549C12.052 12.8773 12.1249 12.1106 11.6649 11.7425C8.47715 9.19155 5.2894 6.64062 2.10165 4.08967C1.64423 3.72363 0.998814 3.65303 0.551177 4.08967C0.164072 4.46728 0.0911341 5.23395 0.551177 5.60209Z",
    fill: "#F9CD11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87694 14.1968C5.47581 10.737 9.07467 7.27711 12.6735 3.81725C13.6801 2.84952 12.1295 1.33729 11.1231 2.30483C7.52419 5.76469 3.92533 9.22456 0.326466 12.6844C-0.680136 13.6521 0.870534 15.1644 1.87694 14.1968Z",
    fill: "#F9CD11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10101 1.03263C4.99721 6.01087 4.89341 10.9891 4.78962 15.9674C4.76091 17.3443 6.95362 17.3441 6.98232 15.9674C7.08612 10.9891 7.18992 6.01087 7.29372 1.03263C7.32242 -0.344278 5.12971 -0.344141 5.10101 1.03263Z",
    fill: "#F9CD11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.a35520bb4e625ae05c3cc6d5685a454a.svg";
export { ForwardRef as ReactComponent };